module.exports = __webpack_public_path__ + "img/kwai.f4bc40db.png";